import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../button/button.jsx';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faQuestionCircle} from '@fortawesome/fontawesome-free-solid/';

import styles from './tips-button.css';
import {JR_THEME} from '../../reducers/topic-project';

const TipsButtonComponent = function (props) {
    return (
        <Button
            className={classNames(styles.tipsButtonWrapper, {
                [styles.tipsButtonWrapperJr]: props.theme === JR_THEME
            })}
            onClick={props.onClick}
        >
            <span className={styles.tipsButtonText}>
                Help
            </span>
            <FontAwesomeIcon
                className={styles.tipsButton}
                draggable={false}
                icon={faQuestionCircle}
                size='lg'
                title={'help button'}
            />
        </Button>
    );
};

TipsButtonComponent.propTypes = {
    onClick: PropTypes.func.isRequired,
    theme: PropTypes.number
};

export default TipsButtonComponent;
